import { useMemo } from 'react';

import { buildDefaultDataProperty } from '@bingads-webui-campaign-react/ui-generator';

export const buildSchema = options => ({
  separatorStyles: {
    marginBottom: 8,
  },
  ads: {
    type: 'panel',
    header: {
      title: _TL_('Ads'),
      as: 'h2',
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit ads'),
        onClick: options.onEditAdsClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      campaignName: buildDefaultDataProperty({
        label: _TL_('Campaign name'),
        dynamicProps: props => props.campaignName,
      }),
      hd1: { type: 'horizontal-divider' },
      companyPage: {
        type: 'li-company-page',
        dynamicProps: props => props.companyInfo,
      },
      hd2: { type: 'horizontal-divider' },
      adCount: {
        type: 'ad-count',
        dynamicProps: props => props.adCount,
      },
    },
  },
  targeting: {
    type: 'panel',
    header: {
      title: _TL_('Targeting'),
      as: 'h2',
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit targeting'),
        onClick: options.onEditTargetingClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      locationTargeting: {
        type: 'location-targeting',
        dynamicProps: props => props.locationTargeting,
      },
      hd1: { type: 'horizontal-divider' },
      languageTargeting: buildDefaultDataProperty({
        label: _TL_('Language'),
        dynamicProps: props => props.languageTargeting,
      }),
      hd2: { type: 'horizontal-divider' },
      linkedInAudienceTargeting: {
        type: 'li-audience-targeting',
        dynamicProps: props => props.linkedInAudienceTargeting,
      },
      hd3: { type: 'horizontal-divider' },
      genderTargeting: {
        type: 'gender-targeting',
        dynamicProps: props => props.genderTargeting,
      },
      hd4: { type: 'horizontal-divider' },
      ageRangeTargeting: {
        type: 'age-range-targeting',
        dynamicProps: props => props.ageRangeTargeting,
      },
    },
  },
  conversions: {
    type: 'panel',
    header: {
      title: _TL_('Conversions'),
      as: 'h2',
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit Conversions'),
        onClick: options.onEditConversionsClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      selectedGoals: {
        type: 'goal-count',
        dynamicProps: props => props.goalCount,
      },
      hd1: { type: 'horizontal-divider' },
      goalDetails: {
        type: 'goal-details',
        dynamicProps: props => props.conversionGoals,
      },
    },
  },
  budget: {
    type: 'panel',
    header: {
      title: _TL_('Budget'),
      as: 'h2',
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit budget'),
        onClick: options.onEditBudgetClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      budget: {
        type: 'budget',
        dynamicProps: props => props.budget,
      },
      hd1: { type: 'horizontal-divider' },
      bidStrategy: {
        type: 'bid-strategy',
        dynamicProps: props => props.bidStrategy,
      },
      hd2: { type: 'horizontal-divider' },
      adScheduleAdGroup: {
        type: 'ad-schedule',
        dynamicProps: props => props.adScheduleAdGroup,
      },
    },
  },
});

export const useSummarySchema = options => useMemo(() => buildSchema(options), [options]);
